/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AudioDemo } from '../models/AudioDemo';
import type { AudioDemoSerializerWithRepr } from '../models/AudioDemoSerializerWithRepr';
import type { PaginatedAudioDemoList } from '../models/PaginatedAudioDemoList';
import type { PaginatedAudioDemoSerializerWithReprList } from '../models/PaginatedAudioDemoSerializerWithReprList';
import type { PatchedAudioDemoSerializerWithRepr } from '../models/PatchedAudioDemoSerializerWithRepr';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AudioDemosService {
    /**
     * @returns PaginatedAudioDemoList
     * @throws ApiError
     */
    public static audioDemosList({
        audioUrl,
        coverUrl,
        createdAt,
        createdBy,
        deletedBy,
        description,
        excludeFields,
        fields,
        lastModifiedAt,
        lastModifiedBy,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
        shortDescription,
        tags,
        videoUrl,
    }: {
        audioUrl?: Array<string>,
        coverUrl?: Array<string>,
        createdAt?: Array<string>,
        createdBy?: Array<string>,
        deletedBy?: Array<string>,
        description?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        lastModifiedAt?: Array<string>,
        lastModifiedBy?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        shortDescription?: Array<string>,
        tags?: Array<string>,
        videoUrl?: Array<string>,
    }): CancelablePromise<PaginatedAudioDemoList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/audio-demos/',
            query: {
                'audio_url': audioUrl,
                'cover_url': coverUrl,
                'created_at': createdAt,
                'created_by': createdBy,
                'deleted_by': deletedBy,
                'description': description,
                'exclude-fields': excludeFields,
                'fields': fields,
                'last_modified_at': lastModifiedAt,
                'last_modified_by': lastModifiedBy,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
                'short_description': shortDescription,
                'tags': tags,
                'video_url': videoUrl,
            },
        });
    }
    /**
     * @returns AudioDemoSerializerWithRepr
     * @throws ApiError
     */
    public static audioDemosCreate({
        requestBody,
    }: {
        requestBody: AudioDemoSerializerWithRepr,
    }): CancelablePromise<AudioDemoSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/audio-demos/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedAudioDemoSerializerWithReprList
     * @throws ApiError
     */
    public static audioDemoBulkUpdate({
        requestBody,
        audioUrl,
        coverUrl,
        createdAt,
        createdBy,
        deletedBy,
        description,
        excludeFields,
        fields,
        lastModifiedAt,
        lastModifiedBy,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
        shortDescription,
        tags,
        videoUrl,
    }: {
        requestBody: Array<AudioDemoSerializerWithRepr>,
        audioUrl?: Array<string>,
        coverUrl?: Array<string>,
        createdAt?: Array<string>,
        createdBy?: Array<string>,
        deletedBy?: Array<string>,
        description?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        lastModifiedAt?: Array<string>,
        lastModifiedBy?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        shortDescription?: Array<string>,
        tags?: Array<string>,
        videoUrl?: Array<string>,
    }): CancelablePromise<PaginatedAudioDemoSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/audio-demos/',
            query: {
                'audio_url': audioUrl,
                'cover_url': coverUrl,
                'created_at': createdAt,
                'created_by': createdBy,
                'deleted_by': deletedBy,
                'description': description,
                'exclude-fields': excludeFields,
                'fields': fields,
                'last_modified_at': lastModifiedAt,
                'last_modified_by': lastModifiedBy,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
                'short_description': shortDescription,
                'tags': tags,
                'video_url': videoUrl,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedAudioDemoSerializerWithReprList
     * @throws ApiError
     */
    public static audioDemoBulkPartialUpdate({
        requestBody,
        audioUrl,
        coverUrl,
        createdAt,
        createdBy,
        deletedBy,
        description,
        excludeFields,
        fields,
        lastModifiedAt,
        lastModifiedBy,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
        shortDescription,
        tags,
        videoUrl,
    }: {
        requestBody: Array<AudioDemoSerializerWithRepr>,
        audioUrl?: Array<string>,
        coverUrl?: Array<string>,
        createdAt?: Array<string>,
        createdBy?: Array<string>,
        deletedBy?: Array<string>,
        description?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        lastModifiedAt?: Array<string>,
        lastModifiedBy?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        shortDescription?: Array<string>,
        tags?: Array<string>,
        videoUrl?: Array<string>,
    }): CancelablePromise<PaginatedAudioDemoSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/audio-demos/',
            query: {
                'audio_url': audioUrl,
                'cover_url': coverUrl,
                'created_at': createdAt,
                'created_by': createdBy,
                'deleted_by': deletedBy,
                'description': description,
                'exclude-fields': excludeFields,
                'fields': fields,
                'last_modified_at': lastModifiedAt,
                'last_modified_by': lastModifiedBy,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
                'short_description': shortDescription,
                'tags': tags,
                'video_url': videoUrl,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static audioDemoBulkDestroy({
        id,
    }: {
        id?: Array<number>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/audio-demos/',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns AudioDemo
     * @throws ApiError
     */
    public static audioDemosRetrieve({
        id,
        audioUrl,
        coverUrl,
        createdAt,
        createdBy,
        deletedBy,
        description,
        excludeFields,
        fields,
        lastModifiedAt,
        lastModifiedBy,
        name,
        readDepth,
        shortDescription,
        tags,
        videoUrl,
    }: {
        /**
         * A unique integer value identifying this audio demo.
         */
        id: number,
        audioUrl?: Array<string>,
        coverUrl?: Array<string>,
        createdAt?: Array<string>,
        createdBy?: Array<string>,
        deletedBy?: Array<string>,
        description?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        lastModifiedAt?: Array<string>,
        lastModifiedBy?: Array<string>,
        name?: Array<string>,
        readDepth?: number,
        shortDescription?: Array<string>,
        tags?: Array<string>,
        videoUrl?: Array<string>,
    }): CancelablePromise<AudioDemo> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/audio-demos/{id}/',
            path: {
                'id': id,
            },
            query: {
                'audio_url': audioUrl,
                'cover_url': coverUrl,
                'created_at': createdAt,
                'created_by': createdBy,
                'deleted_by': deletedBy,
                'description': description,
                'exclude-fields': excludeFields,
                'fields': fields,
                'last_modified_at': lastModifiedAt,
                'last_modified_by': lastModifiedBy,
                'name': name,
                'read_depth': readDepth,
                'short_description': shortDescription,
                'tags': tags,
                'video_url': videoUrl,
            },
        });
    }
    /**
     * @returns AudioDemoSerializerWithRepr
     * @throws ApiError
     */
    public static audioDemosUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this audio demo.
         */
        id: number,
        requestBody: AudioDemoSerializerWithRepr,
    }): CancelablePromise<AudioDemoSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/audio-demos/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns AudioDemoSerializerWithRepr
     * @throws ApiError
     */
    public static audioDemosPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this audio demo.
         */
        id: number,
        requestBody?: PatchedAudioDemoSerializerWithRepr,
    }): CancelablePromise<AudioDemoSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/audio-demos/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static audioDemosDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this audio demo.
         */
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/audio-demos/{id}/',
            path: {
                'id': id,
            },
        });
    }
}
